import { Component, ErrorInfo, ReactNode } from "react";
import posthog from "@/lib/posthog";

interface Props {
  children: ReactNode;
  component?: string;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    const component =
      this.props.component ??
      info.componentStack?.trim().split("\n")[0]?.trim().replace(/^at /, "") ??
      "unknown";

    posthog.captureException(error, { component });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="text-center">
            <p className="text-lg font-semibold text-foreground mb-2">Something went wrong</p>
            <p className="text-sm text-muted-foreground mb-4">Please refresh the page to continue.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
            >
              Refresh
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
